import Box from "@mui/material/Box";
import CustomContainer from "../CustomContainer";
import MostUsedCard from "./MostUsedCard";
import Typography from "@mui/material/Typography";

import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import "../../theme/carouselDots.css";

export default function MostUsedRow({ mostUsedEstablishments }) {
  const cards = mostUsedEstablishments.map(({ nome, count, imagem }) => (
    <MostUsedCard name={nome} count={count}  />
  ));

  return (
    <CustomContainer
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "210px",
        justifyContent: "space-between",
        paddingBottom: "5px",
        marginBottom:"20px"
      }}
    >
      <Typography color="primary" component="h2" pl={2} variant="h6">
        Expecialidades mais procuradas
      </Typography>

      {/* CARROSSEL */}
      <Box>
        <AliceCarousel
          mouseTracking={true}
          items={cards}
          disableButtonsControls
          responsive={{
            0: { items: 6 },
          }}
        />
      </Box>
    </CustomContainer>
  );
}
